export default "__VITE_ASSET__D36hbXjj__"